import { connect } from 'scrivito'

import { TimeTrackingTab } from '../../const'
import {
  MyOrderRow,
  NavigationProps,
  DisplayFormat,
  WeekRange,
} from '../../types'
import { Badge, type Variant } from '@/Atomic/Atoms/Badge'
import { Column, TableRow, TableCell } from '@/Atomic/Templates/Table'
import { getStatusColour } from '@/utils/timerecordUtils'

const colourToVariant: Record<string, Variant> = {
  grey: 'primary',
  blue: 'info',
  green: 'success',
}

interface OrderTableRowProps extends NavigationProps {
  row: MyOrderRow
  displayFormat?: DisplayFormat
  monthRange: WeekRange
  teamLeaderId: string
}

export const OrderTableRow = connect(
  ({
    row,
    navigateToTab,
    navigateToResource,
    monthRange,
    displayFormat = 'days',
    teamLeaderId,
  }: OrderTableRowProps) => {
    const statusColour = getStatusColour(row.status)
    const revenueDisplay =
      displayFormat === 'days' ? `${row.revenueDays}` : `${row.revenue}`
    const totalBudgetDisplay =
      displayFormat === 'days' ? `${row.totalDays}` : `${row.totalBudget}`
    const usedBudgetDisplay =
      displayFormat === 'days' ? `${row.usedDays}d` : `${row.usedBudget}`
    const remainingBudgetDisplay =
      displayFormat === 'days'
        ? `${row.remainingDays}d`
        : `${row.remainingBudget}`

    return (
      <TableRow className="timerecord-row-with-actions">
        <TableCell noWrap variant={Column.WIDTH_120PX}>
          {row.orderType || '—'}
        </TableCell>
        <TableCell noWrap variant={Column.MAIN} className="my-team-clickable">
          <span
            onClick={() =>
              navigateToResource(row.orderId, 'order-details', 'order_id')
            }
          >
            {row.orderTitle || '—'}
          </span>
        </TableCell>
        <TableCell
          noWrap
          variant={Column.WIDTH_260PX}
          className="my-team-clickable"
        >
          <span
            onClick={() =>
              navigateToResource(row.clientId, 'company-details', 'company_id')
            }
          >
            {row.customerName || '—'}
          </span>
        </TableCell>
        <TableCell
          noWrap
          variant={Column.WIDTH_120PX}
          className="my-team-clickable"
        >
          <span
            onClick={() =>
              navigateToTab(TimeTrackingTab.ALL_TIMES, {
                customer: row.clientId,
                order: row.orderId,
                team: 'all',
                teamLeaderId,
                dateRange: monthRange,
              })
            }
          >
            {revenueDisplay}
          </span>
        </TableCell>
        <TableCell noWrap variant={Column.WIDTH_140PX}>
          {totalBudgetDisplay}
        </TableCell>
        <TableCell noWrap variant={Column.WIDTH_140PX}>
          {usedBudgetDisplay}
        </TableCell>
        <TableCell noWrap variant={Column.WIDTH_160PX}>
          {remainingBudgetDisplay}
        </TableCell>
        <TableCell noWrap variant={Column.WIDTH_120PX}>
          <Badge
            variant={colourToVariant[statusColour] ?? 'primary'}
            value={row.status || '—'}
          />
        </TableCell>
      </TableRow>
    )
  },
)
